import dayjs from 'dayjs'

// The Temporal API where the browser ships it (no polyfill in this bundle); typed minimally
// since TS lib definitions don't model the global yet.
type TemporalGlobal = {
  Now: { timeZoneId: () => string }
  Instant: {
    from: (value: string) => {
      toZonedDateTimeISO: (timeZone: string) => {
        year: number
        month: number
        day: number
        hour: number
        minute: number
      }
    }
  }
}

/**
 * Human display form in the browser's local time zone: `h:mm A, YYYY-MM-DD`
 * (e.g. "11:16 AM, 2026-07-30"). Prefers the native Temporal API when available;
 * dayjs is the output-compatible fallback everywhere else.
 */
export function formatDisplayTimestamp(value: string): string {
  if ('Temporal' in globalThis) {
    // TS lib definitions don't model the Temporal global yet; the shape is the TC39-specified
    // API, and the conversion is wrapped so an unexpected value degrades to the dayjs fallback.
    const temporal = globalThis.Temporal as TemporalGlobal
    try {
      const zoned = temporal.Instant.from(value).toZonedDateTimeISO(temporal.Now.timeZoneId())
      const pad = (n: number): string => String(n).padStart(2, '0')
      const hour12 = zoned.hour % 12 === 0 ? 12 : zoned.hour % 12
      const meridiem = zoned.hour < 12 ? 'AM' : 'PM'
      return `${hour12}:${pad(zoned.minute)} ${meridiem}, ${zoned.year}-${pad(zoned.month)}-${pad(zoned.day)}`
    } catch {
      // Fall through: a timestamp shape Temporal.Instant rejects still parses via dayjs below.
    }
  }
  return dayjs(value).format('h:mm A, YYYY-MM-DD')
}
